export default "__VITE_ASSET__DnfG6ao5__"